import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { UpdateMobileNumberState, updateMobileNumberFeatureKey } from '../reducers/update-mobile-number.reducer';
import * as updateMobileNumberState from '../reducers/update-mobile-number.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, UpdateMobileNumberState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee Removed SUB STATE
export const getUpdateMobileState = createSelector(getMainEmployeeState, state => state[updateMobileNumberFeatureKey]);
//#endregion

//#region Employee Removed SUB STATE
export const getUpdateMobileNumberRequest = createSelector(getUpdateMobileState, updateMobileNumberState.updateMobileNumberRequest);
export const getUpdateMobileNumberSuccess = createSelector(getUpdateMobileState, updateMobileNumberState.updateMobileNumberResponse);
export const getUpdateMobileNumberFailure = createSelector(getUpdateMobileState, updateMobileNumberState.updateMobileNumberFailure);
//#endregion
